import React, { lazy, Suspense } from 'react'
import YourClassRoomSkeleton from './skeleton/YourClassRoomSkeleton'
import MonitoringSkeleton from './skeleton/MonitoringSkeleton'
import ActionsSkeleton from './skeleton/ActionsSkeleton'
import StatisticsSkeleton from './skeleton/StatisticsSkeleton'

const YourClassroom = lazy(() => import('./overview/YourClassroom'))
const Monitoring = lazy(() => import('./overview/Monitoring'))
const Actions = lazy(() => import('./overview/Actions'))
const Statistics = lazy(() => import('./overview/Statistics'))

function Overview() {
    return (
        <div className="flex flex-col">
            <div className="">
                <Suspense fallback={<YourClassRoomSkeleton />}>
                    <YourClassroom />
                </Suspense>
            </div>
            <div className="flex flex-row my-[10px] lg:my-[25px]">
                <Suspense fallback={<MonitoringSkeleton />}>
                    <Monitoring />
                </Suspense>
                <div className="flex-1 ml-[10px] 2xl:ml-[25px]">
                    <Suspense fallback={<ActionsSkeleton />}>
                        <Actions />
                    </Suspense>
                </div>
            </div>
            <div className="">
                <Suspense fallback={<StatisticsSkeleton />}>
                    <Statistics />
                </Suspense>
            </div>
        </div>
    )
}

export default Overview
